// const API_BASE_URL = `https://localhost:7212/api`;
// const API_BASE_URL = `https://backendcrs.eregistrationukgov.in/api`;
const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://backendcrs.eregistrationukgov.in/api"
    : "https://localhost:7212/api";

const esignURL =
  process.env.NODE_ENV === "production"
    ? "https://esign.eregistrationukgov.in"
    : "https://localhost:44369";

export { esignURL, API_BASE_URL };

export default API_BASE_URL;
